export default date => new Date(date.toString()).getTime()



// WEBPACK FOOTER //
// ./src/utils/getTimestamp.js